// @flow
import * as React from 'react';
import styled from 'styled-components';
import type { Props } from 'common/modules/ui/components/NotificationContent';
import { IconWrapper, IconSpanWrapper, Wrapper } from 'common/modules/ui/components/NotificationContent';
import SalesEstimationNotification from 'statsradio/modules/notifications/domain/SalesEstimationNotification';
import { SalesNotificationProgress, SalesNotificationError, SalesNotificationSuccess } from './SalesNotificationStates';

function asSalesEstimationNotification(notification: any): SalesEstimationNotification {
  return notification;
}

const RadioImage = styled.img`
  width: 100%;
  height: auto;
`;

export default function SalesEstimationNotificationContent(props: Props) {
  const { notification, actions } = props;

  if (!(notification instanceof SalesEstimationNotification)) {
    throw new Error('cannot render a non sales estimation notification');
  }

  const notif = asSalesEstimationNotification(notification);

  let NotificationContent = SalesNotificationProgress;
  if (notif.isInError()) {
    NotificationContent = SalesNotificationError;
  } else if (!notif.isRunning()) {
    NotificationContent = SalesNotificationSuccess;
  }

  return (
    <div>
      <Wrapper>
        <IconWrapper>
          <IconSpanWrapper>
            <RadioImage src={notif.radio.logo} alt={notif.radio.callSign} />
          </IconSpanWrapper>
        </IconWrapper>
        <NotificationContent notification={notif} />
        {actions}
      </Wrapper>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/notifications/components/salesNotifications/SalesNotificationContent.js